<template>
  <svg :style="style" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon_liebiao_normal" clip-path="url(#clip0_3654_76639)">
      <path id="Vector" d="M10 12H22" :stroke="color" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
      <path id="Vector_2" d="M10 19H22" :stroke="color" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
      <path id="Vector_3" d="M10 5H22" :stroke="color" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
      <path id="Vector_4" d="M6 17H2V21H6V17Z" :stroke="color" stroke-width="1.5" stroke-linejoin="round" />
      <path id="Vector_5" d="M6 10H2V14H6V10Z" :stroke="color" stroke-width="1.5" stroke-linejoin="round" />
      <path id="Vector_6" d="M6 3H2V7H6V3Z" :stroke="color" stroke-width="1.5" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3654_76639">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'sort-two',
  props: {
    color: {
      type: String,
      default: '#376EFF'
      // default: '#fff'
    },
    width: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        width: this.width,
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
      }
    }
  }
}
</script>